module.exports = __webpack_public_path__ + "static/media/polyhouse_blog_img.495e330e.webp";